import React, { useState,useEffect,navigate,useMemo  } from 'react';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import { useForm, Controller } from "react-hook-form";
import Typography from '@mui/material/Typography';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import NativeSelect from '@mui/material/NativeSelect';
import FormHelperText from '@mui/material/FormHelperText';
import { getInspectionsById,  simulateMyInspection} from "../../../REST/inspections";
import { GetList } from '../../../REST/properties';
import {GetAgreements} from '../../../REST/agreements';
import { Checkbox, FormControlLabel } from "@material-ui/core";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const user = JSON.parse(localStorage.getItem("user"))
export default function AddInspection(props) {
 const {handleClose,id} = props
 const [adhoc,setAdhoc] = useState(null)
 const [module,setModule] = useState(null)
 const [properties,setProperties] = useState(null)
 const [agreements,setAgreements] = useState(null)
 const [loaded,setLoaded] = useState(false)
 useEffect(() => {
    getInspectionsById(id)
    .then((res)=>{
         const formData = res.data
          
         setAdhoc(formData.adhoc)
         setModule(formData.module) 
         if(formData.adhoc )
         {
             setLoaded(true)
         }
         else
         {
            if(formData.module == "Property")
              {
                  GetList().then((r)=>{
                    setProperties(r.data)
                  
                    setLoaded(true)
                  })
              }
              else if (formData.module == "Agreement")
              {
                GetAgreements().then((r)=>{
                    setAgreements(r.data)
                    setModule(module) 
                    setLoaded(true)
                  })
              }
         } 
         
             
     }
    )
    .catch((e)=>{ debugger; navigate("/inspection") })
  }, []);
 const getSelect =  ()=>{
    if( module == "Property")
    {
        return [<option key='temp'>Select One</option>].concat(properties.map((e, idx) => {
			 
			return <option key={idx} value={e._id}>{e.name}</option>
		}))
    }
    else if (module == "Agreement")
    {
        return [<option key='temp'>Select One</option>].concat(agreements.map((e, idx) => {
			 
			return <option key={idx} value={e._id}>{e.name}</option>
		}))
    }
    else return []
 }
 const schema = yup.object({
    inspectionfor : yup.string().trim(),     
    name: yup.string().trim().required(),
    email: yup.string().trim().required()
   
}).required();


const { control,watch, handleSubmit, clearErrors, reset, formState: { errors } } = useForm({
    defaultValues: {
         
        name: '',
        email: '',
    },
    resolver: yupResolver(schema)
});

 

const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

const saveForm = (data) => {
    let record = {
        ...data,data:{},
         
        inspectionId:id,status:"Created"
    }
     
    if( module == "Property")
    {
      record.module = "property"   
    }
    else if (module == "Agreement")
    {
      record.module = "agreement"  
    }
   
    simulateMyInspection(record)
    .then(handleClose)	
}
  
   if(!loaded) return (<></>)
  return (
    
      
      <Dialog
        fullScreen
        open={true}
        onClose={()=>{handleClose()}}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ justifyContent: 'space-between' }}>
            <IconButton   edge="start"  color="inherit"  onClick={()=>{handleClose()}}  aria-label="close"  >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Create Inspection
            </Typography>
            <IconButton   edge="start"  color="inherit"  onClick={handleSubmit(saveForm)}  aria-label="close"  >
              <SaveOutlined />
            </IconButton>
             
          
          </Toolbar>


        </AppBar>
        <Box p={2}> 
          { 
          !adhoc && module != null && module.trim() != "" &&          
          <Controller name="inspectionfor" control={control}
            render={({ field }) =>
              <FormControl required error={isError(errors.inspectionfor)} variant='standard' margin='dense' fullWidth>
                <InputLabel shrink>Inspection For</InputLabel>
                <NativeSelect {...field} >{getSelect()}</NativeSelect>
                {errors.inspectionfor && <FormHelperText>{errors.inspectionfor.message}</FormHelperText>}
                        </FormControl>} />
          }
          
            <Controller name="name" control={control}
                render={({ field }) =>
                    <TextField required margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message}
                        fullWidth label='Inspector Name' {...field} />} />
            <Controller name="email" control={control}
                render={({ field }) =>
                    <TextField required margin='dense' error={isError(errors.email)} helperText={errors.email && errors.email.message}
                        fullWidth label='Inspector Email' {...field} />} />
           
      </Box>  
      </Dialog>
     
  );
}